// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Usuario } from '../comum/usuario.model';
import { Setor } from './setor.model';

export class UsuarioSetor extends BaseResourceModel {
  constructor(
    public id?: number,
    public usuario?: Usuario,
    public setor?: Setor,
  ) {
    super();
  }
  static converteJson(json: any): UsuarioSetor {
    return Object.assign(new UsuarioSetor(), json);
  }
}
